// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__1_WVF","container":"modal_container__wHvr8","innerlogo":"modal_innerlogo__1KOwa","socialicons":"modal_socialicons__OiKbH"};